import { Link, useNavigate } from "react-router-dom";
import { LifeBuoy, Search, Headphones } from "lucide-react";

export const PublicHeader = () => {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-slate-200/80">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5 group">
          <span className="grid place-items-center w-9 h-9 rounded-xl bg-[#1A73E8] text-white shadow-sm shadow-blue-500/30 group-hover:scale-105 transition-transform">
            <LifeBuoy className="w-5 h-5" />
          </span>
          <span className="font-heading font-bold text-lg tracking-tight text-slate-900">
            Gsupport <span className="text-slate-400 font-medium">Help</span>
          </span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            data-testid="header-search-btn"
            onClick={() => navigate("/search")}
            className="grid place-items-center w-10 h-10 rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-800 transition-colors"
            aria-label="Search"
          >
            <Search className="w-5 h-5" />
          </button>
          <Link
            to="/support"
            data-testid="header-support-btn"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-full text-sm font-semibold text-white bg-[#1A73E8] hover:bg-[#174EA6] transition-colors"
          >
            <Headphones className="w-4 h-4" />
            <span className="hidden sm:inline">Support</span>
          </Link>
        </div>
      </div>
    </header>
  );
};
